<template>
  <div>
    <recipient v-if="schema.recipient" :model="schema.recipient" />

    <div v-if="!!schema.title" class="mt-2">
      <w-wysiwyg :model="schema.title" :config="titleConfig" />
    </div>

    <div v-if="!!schema.decision" class="mt-2">
      <w-wysiwyg :model="schema.decision" :config="decisionConfig" />
    </div>

    <div v-if="!!schema.judgment" class="mt-2">
      <w-wysiwyg :model="schema.judgment" :config="judgmentConfig" />
    </div>

    <div v-if="!!schema.reason" class="mt-2">
      <w-wysiwyg :model="schema.reason" :config="reasonConfig" />
    </div>

    <div v-if="!!schema.toInformation" class="mt-2">
      <w-wysiwyg :model="schema.toInformation" :config="toInformConfig" />
    </div>

    <div v-if="!!schema.recivers" class="mt-2">
      <w-wysiwyg :model="schema.recivers" :config="toInformConfig" />
    </div>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Recipient from './components/Recipient';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components: { ...components, Recipient },
  props: {
    // schema
    schema: { type: Object, required: true }
  },
  data() {
    return {
      // Konfiguracja adresata
      recipientConfig: { allowedContent: true, height: 150 },

      // Konfiguracja decyzji
      decisionConfig: { allowedContent: true, height: 150 },

      // Konfiguracja orzeczeń
      judgmentConfig: { allowedContent: true },

      // Konfiguracja uzasadnień
      reasonConfig: { allowedContent: true },

      // Konfiguracja sekcji "otrzymują"
      toInformConfig: { allowedContent: true, height: 100 },

      // Konfiguracja sekcji tytuł
      titleConfig: { allowedContent: true, height: 50 }
    };
  }
};
</script>
